import { Route, NavigationGuardNext } from 'vue-router';

/**
 * Guard that sets meta tags for routes that need specific SEO meta tags
 */
function setMetaTagsGuard(to: Route, from: Route, next: NavigationGuardNext): void {
  // Handle robots meta tag
  if (to.meta?.robots) {
    let existingMetaTag = document.querySelector('meta[name="robots"]');
    if (!existingMetaTag) {
      existingMetaTag = document.createElement('meta');
      existingMetaTag.setAttribute('name', 'robots');
      document.head.appendChild(existingMetaTag);
    }
    existingMetaTag.setAttribute('content', to.meta.robots);
  }

  // Always proceed to the next guard
  next();
}

export default setMetaTagsGuard;
